import { Box } from '@mui/material';
import { WidgetProps } from '@rjsf/utils';
import { useQuery } from '@tanstack/react-query';
import { QueryKey } from 'api/model';
import { getLatestWorkflowExecution, getWorkflowExecutions } from 'api/workflows/requests';
import { useParams } from 'react-router';
import ExecutionSelect from './ExecutionSelect';

export default function ExecutionSelectWidget(props: WidgetProps<string>) {
  const { value, onChange, required, disabled, formContext, options } = props;

  const { projectId } = useParams();

  const workflowId = (options as any)?.workflowId ?? (formContext as any)?.formData?.configuration?.workflow_id;
  const label = (options as any)?.label ?? 'Execution';

  const enabled = Boolean(projectId && workflowId);
  const executionsQueryKey = [QueryKey.WorkflowExecutions, { projectId, workflowId }];
  const lastExecutionQueryKey = [QueryKey.WorkflowExecutions, 'last-completed', workflowId];

  const {
    data: list = [],
    isLoading,
    isFetching,
  } = useQuery({
    queryKey: executionsQueryKey,
    queryFn: () =>
      getWorkflowExecutions({
        projectId: projectId ?? '',
        pageParam: 1,
        pageSize: 100,
        workflowId,
        sortDirection: '-',
        sortColumn: 'trigger_time',
        filters: [{ attribute: 'status', operator: 'eq', value: 'COMPLETED' }],
        view: 'summary',
      }),
    enabled,
    staleTime: 30_000,
  });

  const { data: latest } = useQuery({
    queryKey: lastExecutionQueryKey,
    queryFn: () => getLatestWorkflowExecution(workflowId),
    enabled: enabled,
    staleTime: 30_000,
  });

  return (
    <Box sx={{ position: 'relative' }}>
      <ExecutionSelect
        workflowId={workflowId}
        label={label}
        options={list}
        latest={latest ?? undefined}
        value={value}
        onChange={onChange}
        disabled={!enabled || disabled}
        required={required}
        loading={isLoading || isFetching}
        showDefaultLast
      />
    </Box>
  );
}
